import axios from "axios";

export default {
  data() {
    return {
      media_types: [],
      scope_types: []
    };
  },

  methods: {
    getMediaTypes() {
      let path = this.$store.state.endpoint + "/utils/mediaTypes";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(type => {
            this.media_types.push({
              text: this.$t("pressNew.media_types." + type),
              value: type
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getScopeTypes() {
      let path = this.$store.state.endpoint + "/utils/scopeTypes";
      axios
        .get(path)
        .then(response => {
          response.data.forEach(type => {
            this.scope_types.push({
              text: this.$t("pressNew.scope_types." + type),
              value: type
            });
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
